<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col lg="3">
              <h1>
                <feather-icon icon="SearchIcon" size="30" class="mr-50" />
                Pesquisadores
              </h1>
            </b-col>
            <b-col lg="6">
              <b-form @submit.prevent="fetchResearchers">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filtro.name"
                    placeholder="Buscar Pesquisador"
                  />
                </b-input-group>
              </b-form>
            </b-col>
            <b-col lg="3">
              <b-button variant="primary button-right" :to="{ name: 'PesquisadorCadastrar' }">
                Adicionar Pesquisador</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body class="mb-0">
      <b-table
        ref="refResearcherListTable"
        style="min-height: 50vw"
        class="position-relative"
        :items="researchers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="Não há pesquisadores cadastrados"
      >
        <template #cell(areas)="data">
          <div class="d-flex flex-wrap">
            <b-badge
              v-for="area in data.item.areas"
              :key="area"
              variant="light-primary"
              class="mr-25 mb-25"
            >
              {{ formatArea(area) }}
            </b-badge>
          </div>
        </template>

        <template #cell(active)="data">
          <b-badge :variant="data.item.active ? 'light-success' : 'light-danger'">
            {{ data.item.active ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            
            <b-dropdown-item
              :to="{ name: 'PesquisadorEditar', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>

            <b-dropdown-divider />

            <b-dropdown-item
              @click="confirmDeletion(data.item)"
              class="text-danger"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Excluir</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BBadge,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BForm,
} from 'bootstrap-vue'
import { hideSpinner, showSpinner } from '@/services/spinService'
import pesquisadorService from '@/services/pesquisadorService'

export default {
  components: {
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BBadge,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BRow,
    BCol,
    BButton,
    BForm,
  },
  data() {
    return {
      filtro: { name: '' },
      researchers: [],
      tableColumns: [
        { key: 'fullName', label: 'Nome', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'areas', label: 'Áreas', sortable: false },
        { key: 'active', label: 'Status', sortable: true },
        { key: 'actions', label: 'Ações', sortable: false },
      ],
    }
  },
  mounted() {
    this.fetchResearchers()
  },
  methods: {
    async fetchResearchers() {
      showSpinner()
      try {
        this.researchers = await pesquisadorService.getAll(this.filtro)
      } catch (error) {
        console.error('Erro ao buscar pesquisadores:', error)
      } finally {
        hideSpinner()
      }
    },
    formatArea(area) {
      const areas = {
        Educacao: 'Educação',
        TecnologiaDaInformacao: 'Tecnologia da Informação',
        LaboratorioEEntomologia: 'Laboratório e Entomologia',
      }
      return areas[area] || area
    },
    confirmDeletion(researcher) {
      this.$swal({
        title: 'Confirmar Exclusão',
        text: `Tem certeza que deseja excluir o pesquisador "${researcher.fullName}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            showSpinner()
            await pesquisadorService.delete(researcher.id)
            this.$swal({
              title: 'Excluído!',
              text: 'Pesquisador excluído com sucesso.',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
            })
            await this.fetchResearchers()
          } catch (error) {
            console.error('Erro ao excluir pesquisador:', error)
            this.$swal({
              title: 'Erro!',
              text: 'Não foi possível excluir o pesquisador. Tente novamente.',
              icon: 'error',
            })
          } finally {
            hideSpinner()
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
